//  @flow

import React from 'react';
import { useTranslation } from 'react-i18next';

import Heading from '../../Components/Heading';
import ListGroup from '../../Components/ListGroup';
import ImageBlurFallback from '../../Components/ImageBlurFallback';
import { Mentor } from '../../GlobalTypes';

import { CLIENT_URL_IMAGE } from '../../config.local';

type MentorProps = {
  mentors: Array<Mentor>
};

const CompanyMentorCard = (props: Mentor) => {
  const { t } = useTranslation();
  return (
    <div className={`companyMentorCard ${props.className}`}>
      <ImageBlurFallback
        className="companyMentorCard-img"
        src={`${CLIENT_URL_IMAGE}${props.companyLogoUrl}`}
        height="45"
        alt={t('companyMentorCardImgAlt')}
      />
    </div>
  );
};

const companyMentor = (props: MentorProps) => {
  const { t } = useTranslation();
  return (
    <div className="compnayMentor-container">
      <ListGroup
        center
        title={<Heading title={t('companiesMentorsHeading')} />}
        description={t('companiesMentorsPara')}
        count={4}>
        {props.mentors.map(item => (
          <CompanyMentorCard {...item} key={item.id} />
        ))}
      </ListGroup>
    </div>
  );
};

export default companyMentor;



// WEBPACK FOOTER //
// ./src/Pages/Home/CompaniesMentors.js